"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense, useEffect } from "react";
import dynamic from "next/dynamic";
import Header from "@/components/header/Header";
import { useHome } from "@/queries/home";
import HomeHero from "./HomeHero";
import HomeSectionsList from "./HomeSectionsList";
import HomeDiscountModal from "./HomeDiscountModal";
import { useHeroSlides } from "./useHeroSlides";
import { useHomeSections } from "./useHomeSections";
const Footer = dynamic(() => import("@/components/layout/footer/Footer"));
const MobileMenu = dynamic(() => import("@/components/layout/mobilemenu/MobileMenu"));
export default function Home() {
  const $ = _c(22);
  const {
    data: homeResponse,
    isLoading,
    isError
  } = useHome();
  const homeData = homeResponse?.data;
  const heroSlides = useHeroSlides(homeData?.hero?.items, true);
  const {
    visibleSections,
    hasMore,
    sentinelRef
  } = useHomeSections(homeData?.sections);
  let t0;
  if ($[0] !== homeData) {
    t0 = () => {
      if (homeData?.subpages) {
        localStorage.setItem("subpages", JSON.stringify(homeData.subpages));
      }
    };
    $[0] = homeData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = homeData?.subpages;
  let t2;
  if ($[2] !== t1) {
    t2 = [t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t0, t2);
  if (isError) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <><Header /><div className="rounded-xl bg-white/5 p-4 text-sm text-red-300 mx-4 mt-4">خطا در دریافت اطلاعات صفحه اصلی</div></>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Header />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== heroSlides || $[7] !== isLoading) {
    t4 = <div className="mx-auto container max-w-3xl px-4 sm:px-6 md:px-20 relative w-full mt-18 min-h-auto md:min-h-auto lg:mb-5 mb-0 md:mb-0"><HomeHero variant="fullscreengrab" slides={heroSlides} isLoading={isLoading} /></div>;
    $[6] = heroSlides;
    $[7] = isLoading;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== hasMore || $[10] !== isLoading || $[11] !== sentinelRef || $[12] !== visibleSections) {
    t5 = <div className="mx-auto container max-w-3xl px-4 sm:px-6 md:px-10 mt-8 md:mt-0 relative z-40"><HomeSectionsList isLoading={isLoading} visibleSections={visibleSections} hasMore={hasMore} sentinelRef={sentinelRef} /></div>;
    $[9] = hasMore;
    $[10] = isLoading;
    $[11] = sentinelRef;
    $[12] = visibleSections;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <div className="flex flex-col pb-8">{t4}{t5}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Footer />;
    t8 = <MobileMenu />;
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Suspense fallback={null}><HomeDiscountModal /></Suspense>;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6) {
    t10 = <>{t3}{t6}{t7}{t8}{t9}</>;
    $[20] = t6;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}